// ********************* react import *******************
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";


// ********************* utils function *******************
import { capitalizeFirstLetter } from "../../../utils/redirections";
import { WordTitle } from "../../../utils/commonFunction";
import { debounce } from "../../../utils/redirections";

// ***************************** interface *******************
import { ChildProps } from "../../../utils/types/interFace";
import { sortInterFace } from "../../../utils/types/interFace";

// ***************************** components *******************
import CommonHeader from "../../../components/common-header";
import Table from "../../../components/table/table";
import { ConfirmPopup } from "../../../components/model-popup/confirmation-popup";
import { CustomButton } from "../../../components/buttons/button";
import { toast} from "react-toastify";

// ********** Redux & API ************
import { FetchNotesErrorListByError } from "../../../redux/slices/noteserror.slice";
import { RemoveNotesAPI,DeleteMultiplenotesAPI } from "../../../api/delete";
import { getPCCLocation } from "../../../api/list";

// ***************************** icons *******************
import EditIcon from "../../../assets/icons/edit.png";
import DeleteIcon from "../../../assets/icons/trash.png";
import { FiFileText } from "react-icons/fi";

//edit modal
import { EmptyLocationErrorPopup } from "./empty-location-error-popup";




const EmptyLocationError = ({filteredAccess}:ChildProps) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(true);
  const userAccess = filteredAccess.length !== 0 ? filteredAccess[0] : {}
  const NotesErrorData = useSelector(
    (state: any) => state?.NotesErrorList?.NotesErrorList || {}
  );


  const [facList,setFacList] = useState([])

  // ********************for table *******************
  //
  const [filterStatus, ] = useState("");

  // search
  const [showSearch, setShowSearch] = useState("");
  const [search, setSearch] = useState<string>("");
  const handleSearch = useCallback(debounce(setSearch, 500), []);

  // sort
  const [sort, setSort] = useState<sortInterFace>({ created_at: "desc" });

  const [limit, ] = useState<number>(15);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [totalRecord, setTotalRecord] = useState<number>(0);

  // editview
  const [ViewDetails, setViewDetails] = useState<any>({});
  const [modelTitle, setModelTitle] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(false);

  // delete
  const [showDeleteModel, setShowDeleteModel] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [multiDelete, setMultiDelete] = useState<any>(false);

  // handle the loading the data
  const handleNotesErrorData = (
    load: boolean,
    sorting: any = {},
    pageNumber?: number
  ) => {
    pageNumber && setPage(pageNumber);
    if (pageNumber || page === 1) {
      setLoader(load);
      setSelectedRows([])
    }
    dispatch(
      FetchNotesErrorListByError({
        page: pageNumber || page,
        limit,
        status: filterStatus,
        error:'Location is empty',
        sort_by:
          Object.keys(sorting).length !== 0
            ? Object.keys(sorting)[0]
            : "created_at",
        sort_dir:
          Object.keys(sorting).length !== 0
            ? sorting[Object.keys(sorting)[0]]
            : "desc",
        search_value: search,
      })
    ).then((res: any) => {
      setTotalPage(res?.payload?.total_pages);
      setTotalRecord(res?.payload?.total_count);
      setLoader(false);
    });
  };

  const handleNextPage = () => {
    setPage(page + 1);
  };

  const afterChangeNotesList = () => {
    if (page === 1) {
      handleNotesErrorData(true, sort);
    } else {
      setPage(1);
    }
  };

  const handleDelete = async () => {
    setButtonLoader(true);
    await RemoveNotesAPI(ViewDetails?.id).then((res: any) => {
      setShowDeleteModel(false);
      if (res?.result?.success) {
        afterChangeNotesList();
        setMultiDelete(false)
        setViewDetails({});
        toast.success(res?.result?.message);
      } else {
        toast.error(res?.message || "User delete failed");
      }
      setButtonLoader(false);
    });
  };

  const handleMultiDelete = async () => {
      setButtonLoader(true);
      const selectedIds = selectedRows.map((row: any) => row?.id);
      const notes_list = { list_notes_id: selectedIds };
      await DeleteMultiplenotesAPI(notes_list).then(async (res: any) => {
        setShowDeleteModel(false);
        if (res?.success) {
          setViewDetails({});
          setMultiDelete(false);
          setSelectedRows([]);
          afterChangeNotesList()
          toast.success(res?.message);
        } else {
          toast.error(res?.message || res?.detail?.message || "Users delete failed");
        }
        setButtonLoader(false);
      });
    };

  const showCheckboxCondition = (row:any)=>{
     return row.status === 'Removed' ? false : true
  }

  /**
     * @function handleFaclities
     * @returns
     * @description handle faclities
     * */
    const handleFaclities = async () => {
      try {
        const result = await getPCCLocation();
        if (result?.result) {
          setFacList(result?.result?.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

 


    const redirectNotesPage = (row:any)=>{
      window.open(`/notes/${row?.id}`, '_blank');
    }

  // all use effect function
  useEffect(()=>{
    handleFaclities()
  },[])

  useEffect(() => {
    handleSearch(showSearch);
  }, [showSearch]);

  useEffect(() => {
    setPage(1);
   }, [limit, search, filterStatus]);
 

  useEffect(() => {
    handleNotesErrorData(true, sort);
  }, [page, sort,search]);
  
  

  // status colour
  const getStatusClass = (status: string): string => {
    switch (status.toLowerCase()) {
      case "pending":
        return "bg-slate-100 border-slate-500 text-slate-800";
      case "removed":
        return "bg-yellow-100 border-yellow-500 text-yellow-800";
      case "completed":
        return "bg-green-100 border-green-500 text-green-800";
      case "updated":
        return "bg-blue-100 border-blue-500 text-blue-800";
      case "error":
        return "bg-red-100 border-red-500 text-red-800";
      default:
        return "bg-gray-100 border-gray-500 text-gray-800 ";
    }
  };

  interface StatusCellProps {
    status?: string;
  }

  const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
    return (
      <div
        className={`max-w-[500px] truncate cursor-default px-1.5 py-1 rounded-lg text-sm text-center font-medium border ${getStatusClass(
          status || ""
        )}`}
      >
        {status || "Unknown"}
      </div>
    );
  };

  return (
    <div className="w-full p-[10px] pl-[2px] pr-[2px]">
      <div className="pt-[16px]  pl-[2px] pr-[2px] bg-white rounded-[12px]">
        <CommonHeader
          heading="No location"
          description="No facility location has been specified. Please select a valid location from the available options to proceed."
          note="Updated records will be processed automatically during the next update cycle."
          totalCount={totalRecord}
          countForText="Results"
          setShowSearch={setShowSearch}
          showSearch={showSearch}
          search
        />
        <Table
          loading={loader}
          data={NotesErrorData}
          showCheckbox={userAccess.delete_access}
          tableScroll={"100%"}
          sort={true}
          showCheckboxCondition = {showCheckboxCondition}
          setSelectedRows={setSelectedRows}
          MultiDeletedFucn={() => {
            setMultiDelete(true);
            setTimeout(() => {
              setShowDeleteModel(true);
            }, 10);
          }}
          selectedRows={selectedRows}
          Clickable={true}
          rowClick={(row: any) => {
            redirectNotesPage(row)
          }}
          hasNextPage={page < totalPage}
          NextPageData={handleNextPage}
          columns={[
            "Patient",
            "DOB",
            "Gender",
            "Sender",
            "Location",
            "DOS",
            "Status",
            "Action",
          ]}
          sortTitleKeys={{
            Patient: "patient_last_name",
            Sender: "sender_name",
            Location: "location",
            DOS: "encounter_date",
            Gender: "gender",
            Status: "status",
          }}
          handleSortfunc={(key: any, value: any) => {
            setSort({ [key]: value });
            page === 1
              ? handleNotesErrorData(false, { [key]: value })
              : handleNotesErrorData(false, { [key]: value }, 1);
          }}
          scopedSlots={{
            Patient: ({ row }: any) => (
              <td title={`${row?.patient_last_name || ""} ${row?.patient_first_name || ""}`}>
                {row?.patient_detail?.patient_id ? (
                  <a
                    href={`/patient-lookup/${row?.patient_detail?.patient_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-blue-500"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div className="max-w-[200px] truncate cursor-pointer">
                      {![null, ""].includes(row.patient_last_name) &&
                        ![null, ""].includes(row.patient_first_name)
                        ? `${WordTitle(row.patient_last_name)}, ${WordTitle(row.patient_first_name)}`
                        : WordTitle(row.patient_last_name || row.patient_first_name||"")}
                    </div>
                  </a>
                ) : (
                  <div className="max-w-[200px] truncate cursor-pointer">
                    {![null, ""].includes(row.patient_last_name) &&
                      ![null, ""].includes(row.patient_first_name)
                      ? `${WordTitle(row.patient_last_name)}, ${WordTitle(row.patient_first_name)}`
                      : WordTitle(row.patient_last_name || row.patient_first_name||"")}
                  </div>
                )}
              </td>
            ),
            Sender: ({ row }: any) => (
              <td title={row?.sender_name || ""}>
                <div className=" max-w-[200px] truncate cursor-pointer">
                  {WordTitle(row?.sender_name || "")}
                </div>
              </td>
            ),
            Location: ({ row }: any) => (
              <td title={row?.location || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {WordTitle(row?.location || "")}
                </div>
              </td>
            ),
            DOS: ({ row }: any) => (
              <td title={row?.encounter_date || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.encounter_date || ""}
                </div>
              </td>
            ),
            DOB: ({ row }: any) => (
              <td title={row?.DOB || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.DOB || ""}
                </div>
              </td>
            ),
            Gender: ({ row }: any) => (
              <td title={row?.gender || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.gender ? WordTitle(row?.gender) : ''}
                </div>
              </td>
            ),
            Status: ({ row }: any) => (
              <td>
                <StatusCell status={capitalizeFirstLetter(row.status)} />
              </td>
            ),
            Action: ({ row }: any) => {
              const isRemovedOrCompleted = row.status.toLowerCase() === "removed" || row.status.toLowerCase() === "completed";
              return (
                <td onClick={(e) => e.stopPropagation()}>
                  <div className="flex gap-[16px] items-center justify-center pr-[4px]">
                    { !isRemovedOrCompleted &&
                      userAccess.update_access && 
                      <img
                        src={EditIcon}
                        alt="Edit"
                        className="cursor-pointer w-[18px] h-[18px]"
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setViewDetails(row);
                          setModelTitle("Update location");
                          setShowModal(true);
                        }}
                      />
                    }
                     
                     {
                      !isRemovedOrCompleted &&
                       userAccess.delete_access &&
                         selectedRows.length <= 1 &&
                      <img
                        src={DeleteIcon}
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setMultiDelete(false)
                          setShowDeleteModel(true);
                          setViewDetails(row);
                        }}
                        alt="Delete"
                        className="cursor-pointer w-[18px] h-[18px]"
                      />
                     }
                    <a
                      href={`/notes/${row.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="no-underline"
                      onClick={(e) => {
                        e.stopPropagation(); 
                      }}
                    >
                      <FiFileText fontWeight={900} fontSize={22} title="Notes Content" />
                    </a>
                  </div>
                </td>
              );
            },
          }}
        />

        {/* ************* editing modal **************/}
        {showModal ? (
          <EmptyLocationErrorPopup
            showModal={showModal}
            setShowModal={setShowModal}
            afterChangeNotesList={afterChangeNotesList}
            handleClose={() => {
              setViewDetails({});
              //  setDecrypt("");
              setShowModal(false);
              //  setViewPopup(false);
            }}
            title={modelTitle}
            setTitle={setModelTitle}
            poupDetails={ViewDetails}
            facList={facList}

          />
        ) : null}

        <ConfirmPopup showModal={showDeleteModel} icon>
          <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
            Remove Notes?
          </div>
          <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
            You are about to delete{" "}
            <span className="font-semibold">
              {multiDelete
                ? `${selectedRows?.length} notes`
                : `“${ViewDetails?.mrn}(MRN)” notes`}
            </span> {" "}
            Are you sure you want to continue?
          </div>
          <div className="flex justify-center gap-[16px] items-center w-full">
            <CustomButton
              buttonName="No, Keep it"
              primary={false}
              buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              disable={buttonLoader}
              onClick={() => {
                setShowDeleteModel(false);
                setViewDetails({});
              }}
            />
            <CustomButton
              buttonName="Yes, Remove !"
              buttonStyle="w-full text-white bg-[#D41E1E] hover:bg-[#B51C1C] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              loader={buttonLoader}
              disable={buttonLoader}
              loaderStyle="w-full bg-[#D41E1E]/80  py-[13px] "
              onClick={() => {
                multiDelete ? handleMultiDelete() : handleDelete();
              }}
            />
          </div>
        </ConfirmPopup>
      </div>
    </div>
  );
};

export default EmptyLocationError;
